import styled from 'styled-components';
import { colors, weights } from '~/styles';

// Stat card grid
export const Grid = styled.div`
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 1.5rem;
`;

export const Card = styled.div`
  padding: 1.5rem;
  border: solid 1px ${colors.grey10};
  border-radius: 0.5rem;
`;

export const CardLabel = styled.div`
  font-size: 0.875rem;
  color: ${colors.grey50};
  margin-bottom: 0.5rem;
`;

export const CardValue = styled.div`
  font-size: 2rem;
  font-weight: ${weights.bold};
  color: ${colors.black};
`;

export const CardSubValue = styled.div`
  font-size: 0.875rem;
  color: ${colors.grey50};
  margin-top: 0.25rem;
`;

// Section layout
export const Section = styled.div`
  margin-bottom: 2rem;
`;

export const SectionTitle = styled.h3`
  margin-bottom: 1rem;
`;

// Chart labels (lighter than section titles)
export const ChartLabel = styled.div`
  font-size: 0.875rem;
  color: ${colors.grey50};
  margin-top: 1.5rem;
  margin-bottom: 0.5rem;
`;

export const ChartWrapper = styled.div`
  height: 16rem;
`;

export const NoData = styled.div`
  padding: 2rem;
  text-align: center;
  color: ${colors.grey25};
  font-size: 0.875rem;
`;

// Formatters
export function formatCost(value) {
  return new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD' }).format(value);
}

export function formatNumber(value) {
  return new Intl.NumberFormat('en-US').format(value);
}
